/*
 * CRO: PDP add-to-cart button becomes "Continue to checkout" once the
 * current variant is in the cart, and then routes to checkout on click.
 * Self-contained, idempotent, vanilla JS. Does not modify theme core JS.
 */
(function () {
  if (window.__croPdpCheckoutCta) return;
  window.__croPdpCheckoutCta = true;

  var CHECKOUT_LABEL = 'Continue to checkout';
  var ADD_LABEL = 'Add to Bag';

  function getButtons() {
    return document.querySelectorAll('[data-main-product-add-to-cart]');
  }

  function getVariantIdFor(btn) {
    var form = btn.closest('form');
    if (!form) return null;
    var input = form.querySelector('input[name="id"]');
    return input ? parseInt(input.value, 10) : null;
  }

  function getCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .catch(function () { return null; });
  }

  function toCheckout(btn) {
    var textEl = btn.querySelector('[data-js-product-add-to-cart-text]');
    if (textEl) textEl.textContent = CHECKOUT_LABEL;
    var priceEl = btn.querySelector('.kt-button__price');
    if (priceEl) priceEl.style.display = 'none';
    btn.setAttribute('data-in-cart', 'true');
  }

  function toAdd(btn) {
    btn.setAttribute('data-in-cart', 'false');
    var priceEl = btn.querySelector('.kt-button__price');
    if (priceEl) priceEl.style.display = '';
    var textEl = btn.querySelector('[data-js-product-add-to-cart-text]');
    if (textEl && textEl.textContent.trim() === CHECKOUT_LABEL) {
      textEl.textContent = ADD_LABEL;
    }
  }

  function sync() {
    var btns = getButtons();
    if (!btns.length) return;
    getCart().then(function (cart) {
      if (!cart || !cart.items) return;
      Array.prototype.forEach.call(btns, function (btn) {
        var vId = getVariantIdFor(btn);
        var inCart = vId && cart.items.some(function (i) { return i.variant_id === vId; });
        if (inCart) { toCheckout(btn); } else { toAdd(btn); }
      });
    });
  }

  /* When button is already in "Continue to checkout" state, route to checkout. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-main-product-add-to-cart][data-in-cart="true"]');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = '/checkout';
  }, true);

  /* After a normal add click, re-check the cart and update the label. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-main-product-add-to-cart]');
    if (!btn) return;
    if (btn.getAttribute('data-in-cart') === 'true') return;
    setTimeout(sync, 800);
    setTimeout(sync, 1600);
  });

  /* Variant change can swap availability/variant; re-sync. */
  document.addEventListener('change', function (e) {
    if (e.target.closest('product-form, [data-type="add-to-cart-form"]')) {
      setTimeout(sync, 250);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
})();
